<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aacubm/tc-custom/9781497659223.jpg?1701061291472" alt="This image is the cover for the book Loonglow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Loonglow
      </h1>
      <p class="bookDescription body article font2">
        <b>Young New Yorkers negotiate challenging relationships in this “sharp, witty and touching” novel of friendship, sex, and love (<i>Time Out</i>).</b><br/><br/> Manhattan offers the promise of escape for an aimless young man from Memphis. When Clay Lee comes to town hoping to take refuge from family ghosts, he has no idea that a fleeting encounter with an impossibly beautiful woman will upend his life. What begins as a brief obsession becomes the catalyst for exploring the meaning of love itself—in ways Clay could never have anticipated. As he attempts to get his hard-won lessons into focus—and print—he enters a world he didn’t know existed.<br/>  <br/> Wry New York book editor Louisa Mercer has a puzzle she can’t solve: Her love affair with the dazzling, mercurial Mia D’Allesandro has imploded for reasons she can’t pinpoint, and she can’t seem to break its spell. When Louey discovers a manuscript with more than a few direct applications to her own life, her collaboration with its author transforms them both.<br/>  <br/> With New York City as its glittering backdrop, <i>Loonglow</i> explores the exhilarating and heartbreaking turns that life delivers to both the victors and the victims of love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Eisenbach
      </h2>
      
      <p class="authorDescription body article">Helen Eisenbach writes comedies for both screen and stage and has published two books, the novel&#160;<I>Loonglow</I>&#160;and the slyly optimistic how-to <I>Lesbianism Made Easy</I>. Her essays, reviews, and interviews may be read at the <I>Huffington Post</I> and <I>429Magazine </I>and have appeared in <I>New York</I> magazine, the <I>New York Times, Salon</I>, <I>Newsday</I>, <I>Time Out New York</I>, <I>Interview</I>, the New York <I>Daily News</I>, and other tasteful publications. She has been a book and magazine editor at several outlets that no longer exist, and now works at a mainstream publication whose fate remains uncertain. She is currently developing several screenplays and a new novel.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f0b9840e